import React from 'react';
import ReactDOM from 'react-dom/client';
import $ from 'jquery';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';

import GTMContainer from '@/components/gtmContainer/GTMContainer';
import App from "@/app";
import '@/styles/index.scss';
import "@/styles/TabCompanyProfilesStyles.scss";
import "@/styles/SinglePageSearchStyles.scss";
import 'tippy.js/dist/tippy.css';
import "@/styles/BusinessDirectoryStyles.scss";
import i18n from '@/i18n/config';

window.$ =  window.jQuery = $;   

window.process = {
  env: {
    NODE_ENV: process.env.NODE_ENV || 'development',
  },
};

const root = ReactDOM.createRoot(document.getElementById('root'));
window.digitalData = window.digitalData || {};

root.render(
  <BrowserRouter>
    <I18nextProvider i18n={i18n}>
    <GTMContainer />
      {process.env.REACT_APP_API_ENVIRONMENT === "local" ?
        <React.StrictMode>
          <App />
        </React.StrictMode> : <App />
      }
    </I18nextProvider>
  </BrowserRouter>
);